import { Box } from '@usealloy/component-library';
import styled from 'styled-components';

export const FormulaTextWrapper = styled(Box)({
  fontFamily: 'var(--cl-font-family-mono)',
  lineHeight: 'var(--cl-line-height-3)',
});

export const StyledColoredDot = styled.div<{ isVisible: boolean; color?: string }>`
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  width: var(--cl-space-2);
  height: var(--cl-space-2);
  background-color: ${({ color }) => (color || 'var(--cl-green-300)')};
  border-radius: 100%;
  flex: 0 0 var(--cl-space-2);
  z-index: 1;
`;

